import { createSlice } from '@reduxjs/toolkit';
import { stepAction } from '../actions';
import { stepReducer as extraReducers } from '../reducers';
import { IStepState } from '../../interfaces';

const initialState: IStepState = {
  status: 'inactive',
  steps: [],
  error: '',
};

export const stepSlice = createSlice({
  name: 'step',
  initialState,
  // Non-async reducers
  reducers: {
    resetStep: () => {
      return initialState;
    },
  },
  // Async reducers
  extraReducers,
});

// Action creators are generated for each case reducer function
export const stepSliceActions = { ...stepSlice.actions, ...stepAction };

export default stepSlice.reducer;
